import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchActivePartnerLogos = async () => {
  const res = await apiClient.get(`/partner-logos/active`);
  return res.data?.data || [];
};

export const fetchPartnerLogos = async () => {
  const res = await apiClient.get(`/partner-logos/get_all`, getAuthHeader());
  return res.data?.data || [];
};

export const createPartnerLogo = async (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return apiClient.post(`/partner-logos/create`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updatePartnerLogo = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return apiClient.post(`/partner-logos/update/${id}`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deletePartnerLogo = async (id) => {
  return apiClient.delete(`/partner-logos/delete/${id}`, getAuthHeader());
};
